import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";

import logo from "./../../assest/logo-my-color-event.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";

const EventInvoice = () => {
  const { id } = useParams(); // Get the 'id' from route params
  const [products, setProducts] = useState(null); // State for real-time product data
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const personEmail = products?.email;

  const [paymentData, setPaymentData] = useState([]);
  const [totalPayAmount, setTotalPayAmount] = useState(0);

  useEffect(() => {
    if (personEmail) {
      const fetchPaymentData = async () => {
        try {
          const response = await axios.get(
            `https://server-gs.vercel.app/paid/stripe/${personEmail}`
          );
          setPaymentData(response.data);

          // Calculate the total payAmount if available
          const total = response.data.reduce(
            (acc, payment) => acc + (parseFloat(payment.payAmount) || 0),
            0
          );
          setTotalPayAmount(total.toFixed(2)); // Ensure two decimal places
        } catch (err) {
          console.error("Error fetching payment data:", err);
          setError("Failed to fetch payment data");
        }
      };

      fetchPaymentData();
    }
  }, [personEmail]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-profile"
        );
        setData(response.data);
        setError(null); // Clear any previous errors
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        // setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);
  const allProducts = products?.products;

  const productTotalMain = allProducts?.reduce((sum, product) => {
    return sum + (product.productTotal || 0); // Ensure productTotal exists, default to 0 if undefined
  }, 0);

  const totalFinalAmount = allProducts?.reduce((sum, pro) => {
    let total = pro.productTotal;

    // Add tax to the total
    if (pro.tax) {
      const taxValue = (parseFloat(pro.tax) / 100) * total; // Calculate tax as percentage
      total += taxValue;
    }

    // Apply discount if available
    if (pro.discount) {
      if (pro.discountType === "%") {
        const discountValue = (parseFloat(pro.discount) / 100) * total; // Calculate discount as percentage
        total -= discountValue;
      } else if (pro.discountType === "$") {
        const discountValue = parseFloat(pro.discount); // Subtract flat discount
        total -= discountValue;
      }
    }

    // Ensure total is not negative
    total = Math.max(0, total);

    return sum + total; // Add the calculated total for the current product to the sum
  }, 0);

  const AllProductTax = products?.AllProductTax;
  const AllProductDiscount = products?.AllProductDiscount;
  const AllProductDiscountType = products?.AllProductDiscountType;

  let calculateTotalAmount = allProducts?.reduce((sum, pro) => {
    let total = pro.productTotal;

    // Add product-specific tax
    if (pro.tax) {
      const taxValue = (parseFloat(pro.tax) / 100) * total;
      total += taxValue;
    }

    // Apply product-specific discount
    if (pro.discount) {
      if (pro.discountType === "%") {
        const discountValue = (parseFloat(pro.discount) / 100) * total;
        total -= discountValue;
      } else if (pro.discountType === "$") {
        const discountValue = parseFloat(pro.discount);
        total -= discountValue;
      }
    }

    // Ensure product total is not negative
    total = Math.max(0, total);

    return sum + total;
  }, 0);

  // Add AllProductTax if applicable
  if (AllProductTax) {
    const taxValue = (parseFloat(AllProductTax) / 100) * calculateTotalAmount;
    calculateTotalAmount += taxValue;
  }

  // Apply AllProductDiscount if applicable
  if (AllProductDiscount) {
    if (AllProductDiscountType === "%") {
      const discountValue =
        (parseFloat(AllProductDiscount) / 100) * calculateTotalAmount;
      calculateTotalAmount -= discountValue;
    } else if (AllProductDiscountType === "$") {
      const discountValue = parseFloat(AllProductDiscount);
      calculateTotalAmount -= discountValue;
    }
  }

  // Ensure finalAmount is not negative
  const finalAmount = Math.max(0, calculateTotalAmount);

  const totalTaxAmount = allProducts?.reduce((sum, pro) => {
    if (pro.tax) {
      const taxValue = (parseFloat(pro.tax) / 100) * pro.productTotal; // Calculate tax as percentage of productTotal
      return sum + taxValue; // Add the tax value to the running total
    }
    return sum; // If no tax, keep the sum unchanged
  }, 0);

  const totalDiscountAmount = allProducts?.reduce((sum, pro) => {
    // Initialize total with productTotal
    let total = pro.productTotal;

    // Add tax to the total if applicable
    if (pro.tax) {
      const taxValue = (parseFloat(pro.tax) / 100) * pro.productTotal;
      total += taxValue;
    }

    // Calculate the discount amount
    let discountAmount = 0;
    if (pro.discount) {
      if (pro.discountType === "%") {
        discountAmount = (parseFloat(pro.discount) / 100) * total; // Percentage-based discount
      } else if (pro.discountType === "$") {
        discountAmount = parseFloat(pro.discount); // Flat discount
      }
    }

    // Ensure discount amount is non-negative
    discountAmount = Math.max(0, discountAmount);

    // Add the discount amount to the running total
    return sum + discountAmount;
  }, 0);

  // Function to fetch product details
  const fetchProductDetails = async () => {
    try {
      const response = await fetch(`https://server-gs.vercel.app/admin/orders/${id}`);
      const data = await response.json();
      setProducts(data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  useEffect(() => {
    fetchProductDetails(); // Initial fetch

    // Polling every 5 seconds
    const interval = setInterval(() => {
      fetchProductDetails();
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [id]);

  const pdfRef = useRef();
  const downloadPdf = async () => {
    const element = pdfRef.current;
    if (!element) return;

    // Generate canvas from the HTML element
    const canvas = await html2canvas(element, {
      scale: 3, // Higher resolution for better quality
      useCORS: true, // Enable cross-origin image handling
    });

    const imgData = canvas.toDataURL("image/png", 1.0);
    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210; // Width of A4 in mm
    const pageHeight = 297; // Height of A4 in mm

    let imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight; // Shift up by the remaining height
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save("Invoice.pdf");
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="w-full min-h-screen bg-gray-200 py-28">
      <div className="w-[825px] mx-auto flex gap-5 py-4 ">
        <button
          onClick={downloadPdf}
          className="px-6 py-2 rounded-full bg-indigo-500 text-white  text-sm text-wt-md font-jost"
        >
          Download Pdf
        </button>
        <Link to={`/invoice/payment/${products._id}`}>
          <button className="px-6 py-2 rounded-full bg-indigo-500 text-white  text-sm text-wt-md font-jost">
            Pay Invoice
          </button>
        </Link>
      </div>
      <div className="w-[825px]  mx-auto bg-white shadow-sm p-10" ref={pdfRef}>
        <div className="w-full flex justify-between border-b border-gray-400 pb-5">
          <div className="flex flex-row gap-3 items-center w-[60%]">
            <img className="w-36 h-36" src={logo} alt=""></img>
            <div className="flex flex-col gap-1">
              <h1 className="font-jost text-xl font-semibold text-gray-700">
                My color events and design LLC
              </h1>
              <p className="font-jost text-md text-gray-700">
                1565 Monroe Turnpike Monroe, Connecticut 06468 United States
              </p>
              <p className="font-jost text-md text-gray-700">
                info@mycolorevents.com
              </p>
              <p className="font-jost text-md text-gray-700">
                Phone: +1203-548-7769
              </p>
            </div>
          </div>
          <div>
            <h1 className="font-jost text-xl font-semibold text-gray-700">
              Quote: {products.paymentId}
            </h1>
          </div>
        </div>
        {/* from to */}
        <div className="pt-5 flex justify-between gap-5">
          <div className="w-full">
            <h1 className="text-xl font-jost px-4 pb-2 font-semibold">
              Contact
            </h1>
            <div className="w-full  bg-gray-50 rounded-xl p-4">
              <h1 className="text-sm font-jost text-gray-900">
                <span className="font-semibold ">Name:</span>{" "}
                {products.firstName} {products.lastName}
              </h1>
              <h1 className="text-sm font-jost text-gray-900 mt-2">
                <span className="font-semibold">Phone :</span>{" "}
                {products.phoneNumber}
              </h1>
              <h1 className="text-sm font-jost text-gray-900">
                <span className="font-semibold">Email :</span> {products.email}
              </h1>
            </div>
          </div>
          <div className="w-full">
            <h1 className="text-xl font-jost px-4 pb-2 font-semibold">
              Venue / Address
            </h1>
            <div className="w-full  p-4 flex justify-center items-start flex-col bg-gray-50 rounded-xl">
              <div className="flex  flex-col g">
                <div>
                  <h1 className="text-sm font-jost text-gray-900">
                    <span className="font-semibold">Venue :</span>{" "}
                    {products.VenueName}
                  </h1>
                  <h1 className="text-sm font-jost text-gray-900">
                    <span className="font-semibold">Address :</span>{" "}
                    {products.VenueStreetAddressOne}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* products */}
        <div>
          <div className="flex flex-row justify-between gap-4 w-[60%] mt-10">
            <p className="text-md font-roboto text-gray-500">Duration :</p>
            <p className="text-md font-roboto text-gray-500">
              {new Date(products.projectBookingDate).toLocaleString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}{" "}
            </p>
            <h1 className="text-md font-roboto text-gray-500">to</h1>
            <p className="text-md font-roboto text-gray-500">
              {new Date(products.projectSelectEndDate).toLocaleString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
              })}{" "}
            </p>
          </div>
          <div className="flex flex-col gap-5 mt-2">
            {allProducts.map((pro) => (
              <div className="w-full p-5 bg-gray-50 rounded-xl">
                <div className="flex flex-row items-center gap-3 w-full">
                  <div className="w-28">
                    {pro?.deliveryType === "delivery" ? (
                      <img
                        alt=""
                        crossOrigin="anonymous"
                        class="w-14 h-14 rounded-full"
                        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoMSwwLDAsMSwwLDExMCkiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTM2NSAzLjAxNmM0NC4zOSAxMC4zIDYxLjM3MSAzNi4yNTcgODIuNjYgNzEuOTg0SDM2NXpNMTA1LjU3OCA3OGM4LjY5MiAwIDE1IDQuMTk1IDE1IDE0IDAgOC4yNy02LjY5MSAxNC45NzctMTQuOTU3IDE1SDE1Yy04LjI4NSAwLTE1IDYuNzE5LTE1IDE1IDAgOC4yODUgNi43MTUgMTUgMTUgMTVoMTM1YzguMzYzIDAgMTUuMDU5IDYuNzEgMTUuMDU5IDE1IDAgOC4yODUtNi43MTUgMTUtMTUgMTVIMTVjLTguMjg1IDAtMTUgNi43MTUtMTUgMTVzNi43MTUgMTUgMTUgMTVoMzN2NDVjMCA4LjI4NSA2LjcxNSAxNSAxNSAxNWgzMC4xNTJjNS4zNzUgMjYuNDc3IDI4Ljc3IDQ2IDU2LjM0OCA0NnM1MC45NzMtMTkuNTIzIDU2LjM0OC00NmgxNTIuMzA0YzUuMzc1IDI2LjQ3NyAyOC43NyA0NiA1Ni4zNDggNDZzNTAuOTczLTE5LjUyMyA1Ni4zNDgtNDZINDk3YzguMjg1IDAgMTUtNi43MTUgMTUtMTV2LTkwYzAtNDQuMDEyLTQ2LjQyMi00Ni45MzQtNDYuNDY1LTQ3SDM1MGMtOC4yODUgMC0xNS02LjcxNS0xNS0xNVYwSDYzYy04LjI4NSAwLTE1IDYuNzE1LTE1IDE1djMzSDMwYy04LjI4NSAwLTE1IDYuNzE1LTE1IDE1czYuNzE1IDE1IDE1IDE1em0zMjguMzY3IDE0OC4wNTVjMTAuNzM5IDEwLjczOCAxMC43MzkgMjguMTU2IDAgMzguODk0QzQxNi42NzIgMjgyLjIyMyAzODcgMjY5LjkzNCAzODcgMjQ1LjVjMC0yNC40MyAyOS42NzItMzYuNzE5IDQ2Ljk0NS0xOS40NDV6bS0yNjUgMGMxMC43MzkgMTAuNzM4IDEwLjczOSAyOC4xNTYgMCAzOC44OTRDMTUxLjY3MiAyODIuMjIzIDEyMiAyNjkuOTM0IDEyMiAyNDUuNWMwLTI0LjQzIDI5LjY3Mi0zNi43MTkgNDYuOTQ1LTE5LjQ0NXptMCAwIiBmaWxsPSIjMDAwMDAwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                      />
                    ) : (
                      <img
                        class="w-24 h-24 rounded-xl object-cover"
                        src={pro.singleImage}
                        alt="Rounded avatar"
                        crossOrigin="anonymous"
                      />
                    )}
                  </div>
                  <div className="flex flex-col justify-between w-full">
                    <div className=" flex justify-between items-center w-full">
                      <div className="flex flex-col gap-4 w-full">
                        <div className="w-full flex flex-row justify-between">
                          <div className="flex flex-col gap-1">
                            {pro?.deliveryType === "delivery" ? (
                              <h1 className="font-jost text-md text-gray-600">
                                Delivery charge
                              </h1>
                            ) : (
                              <h1 className="font-jost text-md text-gray-600">
                                Item
                              </h1>
                            )}

                            <h1 className="font-jost text-xl text-black">
                              {pro.title}
                            </h1>
                          </div>
                          <div className="">
                            {pro?.deliveryType === "delivery" ? (
                              <div className="flex flex-col gap-1">
                                <h1 className="font-jost text-md text-gray-600">
                                  Total Price:
                                </h1>
                                <h1 className="font-jost text-xl text-black">
                                  {pro?.discount || pro?.tax ? (
                                    <div className="flex flex-col gap-2">
                                      {(() => {
                                        let total = pro?.productTotal;

                                        // Add tax to the total
                                        if (pro?.tax) {
                                          const taxValue =
                                            (parseFloat(pro?.tax) / 100) *
                                            total; // Calculate tax as percentage
                                          total += taxValue;
                                        }

                                        // Apply discount if available
                                        if (pro?.discount) {
                                          if (pro?.discountType === "%") {
                                            const discountValue =
                                              (parseFloat(pro?.discount) /
                                                100) *
                                              total; // Calculate discount as percentage
                                            total -= discountValue;
                                          } else if (
                                            pro?.discountType === "$"
                                          ) {
                                            const discountValue = parseFloat(
                                              pro?.discount
                                            ); // Subtract flat discount
                                            total -= discountValue;
                                          }
                                        }

                                        // Ensure total is not negative
                                        total = Math.max(0, total);

                                        return <span>{total?.toFixed(2)}</span>;
                                      })()}
                                    </div>
                                  ) : (
                                    <span>{pro?.productTotal}</span>
                                  )}{" "}
                                  $
                                </h1>
                              </div>
                            ) : (
                              <div className="flex flex-col gap-1">
                                <h1 className="font-jost text-md text-gray-600">
                                  Price:
                                </h1>
                                <h1 className="font-jost text-xl text-black">
                                  {pro.selectedPricingValue} $
                                </h1>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="flex flex-col gap-1 ">
                          <h1 className="font-jost text-md text-gray-600">
                            Description
                          </h1>
                          {pro?.deliveryType === "delivery" ? (
                            <h1 className="font-jost text-sm text-black">
                              {pro.description}
                            </h1>
                          ) : (
                            <h1 className="font-jost text-sm text-black">
                              {pro.productDescription}
                            </h1>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="border-b  border-gray-200 my-2"></div>
                    <div className=" flex justify-between">
                      {pro?.deliveryType === "delivery" ? (
                        <div className="flex flex-row gap-1">
                          <h1 className="font-jost text-md text-gray-600">
                            Description :
                          </h1>
                          <h1 className="font-jost text-md text-black">
                            {/* {pro.quantity} */}
                          </h1>
                        </div>
                      ) : (
                        <div className="flex flex-row gap-1">
                          <h1 className="font-jost text-md text-gray-600">
                            Quantity :
                          </h1>
                          <h1 className="font-jost text-md text-black">
                            {pro.quantity}
                          </h1>
                        </div>
                      )}
                      {pro?.deliveryType === "delivery" ? (
                        ""
                      ) : (
                        <div className="flex flex-row gap-1">
                          <h1 className="font-jost text-md text-gray-600">
                            TAX :
                          </h1>
                          <h1 className="font-jost text-md text-black">
                            {pro.tax} {pro.tax ? "%" : "0"}
                          </h1>
                        </div>
                      )}

                      {pro?.deliveryType === "delivery" ? (
                        ""
                      ) : (
                        <div className="flex flex-row gap-1">
                          <h1 className="font-jost text-md text-gray-600">
                            Discount :
                          </h1>
                          <h1 className="font-jost text-md text-black">
                            {pro.discount}{" "}
                            {pro.discountType ? pro.discountType : "0"}
                          </h1>
                        </div>
                      )}

                      <div>
                        {pro?.deliveryType === "delivery" ? (
                          ""
                        ) : (
                          <div className="flex flex-row gap-1">
                            <h1 className="font-jost text-xl text-gray-900">
                              Total Price:
                            </h1>
                            <h1 className="font-jost text-xl text-black navFont500">
                              {pro?.discount || pro?.tax ? (
                                <div className="flex flex-col gap-2">
                                  {(() => {
                                    let total = pro?.productTotal;

                                    // Add tax to the total
                                    if (pro?.tax) {
                                      const taxValue =
                                        (parseFloat(pro?.tax) / 100) * total; // Calculate tax as percentage
                                      total += taxValue;
                                    }

                                    // Apply discount if available
                                    if (pro?.discount) {
                                      if (pro?.discountType === "%") {
                                        const discountValue =
                                          (parseFloat(pro?.discount) / 100) *
                                          total; // Calculate discount as percentage
                                        total -= discountValue;
                                      } else if (pro?.discountType === "$") {
                                        const discountValue = parseFloat(
                                          pro?.discount
                                        ); // Subtract flat discount
                                        total -= discountValue;
                                      }
                                    }

                                    // Ensure total is not negative
                                    total = Math.max(0, total);

                                    return <span>{total?.toFixed(2)}</span>;
                                  })()}
                                </div>
                              ) : (
                                <span>{pro?.productTotal}</span>
                              )}
                            </h1>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="w-full flex justify-end  py-4 ">
          <div className=" flex justify-end px-6 py-4 w-[60%]">
            <div className="flex flex-col gap-4 bg-gray-50 p-4">
              <h1 className="text-md font-jost text-gray-600  flex justify-between">
                <strong>Sub Total:</strong> {productTotalMain.toFixed(2)} $
              </h1>
              <hr></hr>
              <h1 className="text-md font-jost text-gray-600  flex justify-between">
                <strong>TAX: </strong>
                {totalTaxAmount.toFixed(2)} $
              </h1>
              <hr></hr>
              <h1 className="text-md font-jost text-gray-600  flex justify-between">
                <strong>Discount: </strong> {totalDiscountAmount.toFixed(2)} $
              </h1>
              <hr></hr>
              <h1 className="text-md font-jost text-gray-900   gap-10 flex justify-between">
                <strong>Total Amount:</strong>{" "}
                <strong>{totalFinalAmount.toFixed(2)} $</strong>
              </h1>
              <hr></hr>
              {products?.AllProductDiscount > 0 ||
              products?.AllProductTax > 0 ? (
                <div className="flex flex-col gap-4">
                  {/* <h1 className="text-md font-jost text-gray-600   gap-10 flex justify-between">
                            <strong>TAX on total amount:</strong>{" "}
                            {products?.AllProductTax}{" "}
                            {products?.AllProductTax === null ? "0 %" : "%"}
                          </h1> */}
                  <h1 className="text-md font-jost text-gray-600    gap-10 flex justify-between">
                    <strong>Discount on Total Amount:</strong>{" "}
                    {(Number(products?.AllProductDiscount) || 0).toFixed(2)}{" "}
                    {products?.AllProductDiscountType}
                  </h1>
                  <hr className="h-0.5 bg-gray-900"></hr>
                  <h1 className="text-md font-jost text-gray-900    gap-10 flex justify-between">
                    <strong>Invoice Total:</strong>{" "}
                    <span className="font-semibold ">
                      {finalAmount.toFixed(2)} $
                    </span>
                  </h1>
                  <hr></hr>
                </div>
              ) : (
                ""
              )}
              {products?.AdvanceDeposit ? (
                <div className="flex flex-col gap-4">
                  {/* <h1 className="text-md font-jost text-gray-600   gap-10 flex justify-between"><strong>Deposit:</strong> {products?.AdvanceDeposit} %</h1> */}
                  <h1 className="text-md font-jost text-gray-600  gap-10 flex justify-between">
                    <strong>Deposit ({products?.AdvanceDeposit} %) :</strong>{" "}
                    {products?.AdvanceDeposit > 0
                      ? (
                          finalAmount *
                          (products?.AdvanceDeposit / 100)
                        ).toFixed(2)
                      : finalAmount.toFixed(2)}{" "}
                    $
                  </h1>
                  <hr></hr>
                </div>
              ) : (
                ""
              )}

              {paymentData.length > 0 ? (
                <div className="flex flex-col gap-4">
                  <h1 className="text-md font-jost text-gray-900  gap-10 flex justify-between">
                    <strong>Paid :</strong> <strong>{totalPayAmount}$</strong>
                  </h1>
                  <hr></hr>
                  <h1 className="text-md font-jost text-gray-900 gap-10 flex justify-between">
                    <strong>Due:</strong>{" "}
                    <strong>
                      {Number(finalAmount - totalPayAmount).toFixed(2)} $
                    </strong>
                  </h1>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div>
          <div className="flex flex-col gap-1 mt-3">
            <p className="text-sm font-jost text-gray-600">
              <strong>Name:</strong> {data?.CompanyName || "N/A"}
            </p>
            <p className="text-sm font-jost text-gray-600">
              <strong>Company ID:</strong> {data?.CompanyId || "N/A"}
            </p>
            <p className="text-sm font-jost text-gray-600">
              <strong>Type:</strong> {data?.CompanyType || "Not specified"}
            </p>
            <p className="text-sm font-jost text-gray-600">
              <strong>Description:</strong>{" "}
              {data?.CompanyDes || "No description available"}
            </p>
            <p className="text-sm font-jost text-gray-600">
              <strong>Website:</strong>{" "}
              {data?.websiteUrl ? (
                <a
                  href={data?.websiteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {data?.websiteUrl}
                </a>
              ) : (
                "N/A"
              )}
            </p>
            <p className="text-sm font-jost text-gray-600">
              <strong>Phone:</strong> {data?.phone || "N/A"}
            </p>
            <p className="text-sm font-jost text-gray-600">
              <strong>Address:</strong> {data?.address || "N/A"}
            </p>
          </div>
          <p className="text-sm font-jost text-gray-600 text-justify mt-5">
            {data?.termsConditions ? (
              <div
                className="text-justify"
                dangerouslySetInnerHTML={{
                  __html: data.termsConditions,
                }}
              ></div>
            ) : (
              ""
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventInvoice;
